import React from 'react';
import { withRouter } from 'react-router-dom';
import Constants from '../utils/Constants';
import PlaceHolderImage from "../assets/img/no_image.png";
import { msToHMS, timeConvert } from '../utils/validation';
import moment from 'moment';
import RenewSubscripton from './alert/RenewSubscription';
import RoutePath from '../utils/routes/RoutePath';


class ViewVendorProfileScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renewSub: false,
            callPriceInput: '',
            rechargeAmount: '',
            rechargeNote: '',
        }
    }

    componentDidUpdate(prevProps) {
        const plan = this.props.rechargePlan;
        if (plan && plan !== prevProps.rechargePlan) {
            this.setState({
                callPriceInput: plan.callPrice != null ? String(plan.callPrice) : '',
            });
        }
    }

    renderProfileTab() {
        const { data } = this.props;
        let count = 0
        data?.Vendor?.VendorAddons?.forEach((o) => {
            count += o.remainingSec
        })
        return (
            <div className='row'>
                <div className="col-md-6">
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.NAME}
                        </div>
                        <div className='col-7'>
                            <p>{data && data.fullName ? data.fullName : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.EMAIL}
                        </div>
                        <div className='col-7'>
                            <p>{data && data.email ? data.email : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.MOBILE_NUMBER}
                        </div>
                        <div className='col-7'>
                            <p>{data && data.phone ? data.phone : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.SUBSCRIPTION_ID}
                        </div>
                        <div className='col-7'>
                            <p>{data && data?.Vendor?.Subscription?.planName ? data?.Vendor?.Subscription?.planName : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.AGENT_TYPE}
                        </div>
                        <div className='col-7'>
                            <p>{data && data?.Vendor?.agentTypeId === 1 ? "Shared Agent" : "Owned Agent"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.TOTAL_TIME}
                        </div>
                        <div className='col-7'>
                            <p>{data.Vendor?.Subscription?.totalMins ? timeConvert(data && data.Vendor?.Subscription?.totalMins) : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.USED_TIME}
                        </div>
                        <div className='col-7'>
                            <p>{data && data.Vendor?.agentCallLimit ? msToHMS(data && data.Vendor?.agentCallLimit) : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.REMAINING_TIME}
                        </div>
                        <div className='col-7'>
                            <p>{data.Vendor?.remainingSec ? msToHMS(data && data.Vendor?.remainingSec + count) : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            Reminder Minutes
                        </div>
                        <div className='col-7'>
                            <p>{data.Vendor?.remainderSec ? msToHMS(data && data.Vendor?.remainderSec) : "-"}</p>
                        </div>
                    </div>
                    {data?.Vendor?.Subscription?.argumentedReality === 1 && <div className='row'>
                        <div className='col-5 text-bold'>
                            Argumented Reality
                        </div>
                        <div className='col-7'>
                            <p>{data.Vendor?.isAR ? (data.Vendor?.isAR == 1 ? "Yes" : "No") : "-"}</p>
                        </div>
                    </div>}
                    {data && data?.Vendor?.VendorAddons?.length > 0 &&
                        <div className='row'>
                            <div className='col-5 text-bold'>
                                {Constants.ADDON_DETAILS}
                            </div>
                            <div className='col-7'>
                                {data && data?.Vendor?.VendorAddons?.map((o) => {
                                    return <>
                                        <ul>
                                            <li>{o?.Addon?.addonPlanName}</li>
                                            <p>({msToHMS(o?.Addon?.totalSec)})</p>
                                        </ul>
                                    </>
                                })}
                            </div>
                        </div>
                    }
                </div>
                <div className="col-md-6">
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.STORE_LOGO}
                        </div>
                        <div className='col-7'>
                            <img style={{ width: '90px', height: '90px', marginBottom: '4px' }} alt="Product" src={data && data?.Vendor?.vendorLogo ? data?.Vendor?.vendorLogo : (PlaceHolderImage)} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.COMPANY_NAME}
                        </div>
                        <div className='col-7'>
                            <p>{data && data?.Vendor?.companyName ? data?.Vendor?.companyName : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.ADDRESS}
                        </div>
                        <div className='col-7'>
                            <p>{data && data?.Vendor?.address ? data?.Vendor?.address : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            Created Date
                        </div>
                        <div className='col-7'>
                            <p>{data?.Vendor?.createdAt ? moment(data?.Vendor?.createdAt).format("DD/MM/YYYY") : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            {Constants.PAYMENT_STATUS}
                        </div>
                        <div className='col-3'>
                            <p>{data?.Vendor?.paymentStatus === 0 ? "Pending" : "Done"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            Payment Completed Date
                        </div>
                        <div className='col-7'>
                            <p>{data?.Vendor?.PaymentTransaction?.createdAt ? moment(data?.Vendor?.PaymentTransaction?.createdAt).format("DD/MM/YYYY") : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            Subscription Start Date
                        </div>
                        <div className='col-3'>
                            <p>{data?.Vendor?.subscriptionStartDate ? moment(data?.Vendor?.subscriptionStartDate).format("DD/MM/YYYY") : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            Subscription End Date
                        </div>
                        <div className='col-3'>
                            <p>{data?.Vendor?.subscriptionEndDate ? moment(data?.Vendor?.subscriptionEndDate).format("DD/MM/YYYY") : "-"}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-5 text-bold'>
                            Remaining Day
                        </div>
                        <div className='col-3'>
                            <p>{data?.Vendor?.dayCount ? data?.Vendor?.dayCount : "-"}</p>
                        </div>
                    </div>
                    {data && data?.Vendor?.agentTypeId === 1 &&
                        <div className='row'>
                            <div className='col-5 text-bold'>
                                {Constants.AGENT_NAME}
                            </div>
                            <div className='col-7'>
                                {data && data?.Vendor?.VendorAgents?.map((o) => {
                                    return <>
                                        <ul>
                                            <li>{o?.User?.fullName}</li>
                                        </ul>
                                    </>
                                })}
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className="col-6">
                            <button className="btn input-btn" onClick={() => this.setState({ renewSub: true })} type="button"><i className="fa-solid me-1"></i>Renew Subscription</button>
                        </div>

                        <div className="col-6">
                            <button className="btn input-btn" onClick={() => this.props.history.push(RoutePath.VENDOR_PROFILE_UPDATE)} type="button"><i className="fa-solid me-1"></i>Edit Profile</button>
                        </div>
                    </div>
                    {this.state.renewSub && <RenewSubscripton
                        id="Alert"
                        searchField={false}
                        title={"Renew your subscription"}
                        proceed="Submit"
                        vendorId={data && data.Vendor && data.Vendor.id}
                        cancel="Cancel"
                        onSuccess={() => this.logout()}
                        onFailure={() => this.setState({ renewSub: false })}
                    />}
                </div>
            </div>
        );
    }

    renderRechargeTab() {
        const plan = this.props.rechargePlan || {};
        const usage = Number(plan.monthUsagePercent != null ? plan.monthUsagePercent : plan.usagePercent) || 0;
        const remainingPct = Number(plan.remainingPercent) || 0;
        const lifetimeUsage = Number(plan.usagePercent) || 0;
        const ledger = Array.isArray(plan.ledger) ? plan.ledger : [];
        const monthOptions = Array.isArray(plan.monthOptions) && plan.monthOptions.length
            ? plan.monthOptions
            : (Array.isArray(plan.monthlyBreakdown) ? plan.monthlyBreakdown : []);
        const selectedMonth = this.props.selectedMonth || plan.selectedMonth || (monthOptions[0] && monthOptions[0].key) || '';
        const monthLabel = plan.monthLabel || 'This month';
        const monthUsedAmt = plan.monthUsed != null ? plan.monthUsed : 0;
        const monthRechargedAmt = plan.monthRecharged != null ? plan.monthRecharged : 0;
        const isCurrentMonth = plan.selectedMonthIsCurrent !== false;
        const eventLabel = (type) => {
            if (type === 'RECHARGE') return 'Recharge';
            if (type === 'CALL_CHARGE') return 'Call charge';
            if (type === 'PRICE_CHANGE') return 'Price change';
            return type || '-';
        };
        return (
            <div className="recharge-plan-panel">
                {this.props.rechargeError ? (
                    <div className="recharge-alert recharge-alert-error">{this.props.rechargeError}</div>
                ) : null}
                {this.props.rechargeSuccess ? (
                    <div className="recharge-alert recharge-alert-ok">{this.props.rechargeSuccess}</div>
                ) : null}

                <div className="recharge-hero">
                    <div className="recharge-hero-text">
                        <h3>Call credit wallet</h3>
                        <p>Turn the feature on/off, choose whether to block patients at 100% usage, set price, and recharge.</p>
                    </div>
                    <div className="recharge-hero-meter">
                        <div className="recharge-meter-ring" style={{ '--pct': `${Math.min(100, remainingPct)}%` }}>
                            <span>{remainingPct}%</span>
                            <small>Remaining</small>
                        </div>
                    </div>
                </div>

                <div className="recharge-month-filter">
                    <div className="recharge-month-filter-text">
                        <strong>Month filter</strong>
                        <p>View usage and ledger for the selected month. Wallet remaining is always current.</p>
                    </div>
                    <select
                        className="recharge-month-select"
                        value={selectedMonth}
                        disabled={this.props.rechargeLoading || !monthOptions.length}
                        onChange={(e) => this.props.onSelectRechargeMonth && this.props.onSelectRechargeMonth(e.target.value)}
                    >
                        {monthOptions.map((opt) => (
                            <option key={opt.key} value={opt.key}>
                                {opt.label}{opt.isCurrent ? ' (current)' : ''}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="recharge-config-card">
                    <h4>Feature settings</h4>
                    <div className="recharge-toggle-row">
                        <div>
                            <strong>Enable Recharge Plan</strong>
                            <p>Yes = track usage and apply call charges. No = feature off (no charge / no block).</p>
                        </div>
                        <div className="recharge-toggle-btns">
                            <button
                                type="button"
                                className={`recharge-toggle ${plan.featureEnabled ? 'is-on' : ''}`}
                                disabled={this.props.rechargeLoading}
                                onClick={() => this.props.onUpdateRechargeSettings({
                                    featureEnabled: 1,
                                    blockOnLimit: plan.blockOnLimit ? 1 : 0,
                                })}
                            >
                                Yes
                            </button>
                            <button
                                type="button"
                                className={`recharge-toggle ${!plan.featureEnabled ? 'is-on' : ''}`}
                                disabled={this.props.rechargeLoading}
                                onClick={() => this.props.onUpdateRechargeSettings({
                                    featureEnabled: 0,
                                    blockOnLimit: plan.blockOnLimit ? 1 : 0,
                                })}
                            >
                                No
                            </button>
                        </div>
                    </div>
                    <div className="recharge-toggle-row">
                        <div>
                            <strong>Block patient when limit reached</strong>
                            <p>Yes = at 100% usage show popup and stop new calls. No = still track usage but never block patients. Calls stay allowed while remaining is above 0%.</p>
                        </div>
                        <div className="recharge-toggle-btns">
                            <button
                                type="button"
                                className={`recharge-toggle ${plan.blockOnLimit !== false && plan.blockOnLimit !== 0 ? 'is-on' : ''}`}
                                disabled={this.props.rechargeLoading || !plan.featureEnabled}
                                onClick={() => this.props.onUpdateRechargeSettings({
                                    featureEnabled: plan.featureEnabled ? 1 : 0,
                                    blockOnLimit: 1,
                                })}
                            >
                                Yes
                            </button>
                            <button
                                type="button"
                                className={`recharge-toggle ${plan.blockOnLimit === false || plan.blockOnLimit === 0 ? 'is-on' : ''}`}
                                disabled={this.props.rechargeLoading || !plan.featureEnabled}
                                onClick={() => this.props.onUpdateRechargeSettings({
                                    featureEnabled: plan.featureEnabled ? 1 : 0,
                                    blockOnLimit: 0,
                                })}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>

                <div className="recharge-stat-grid">
                    <div className="recharge-stat">
                        <span className="recharge-stat-label">Per-call price</span>
                        <span className="recharge-stat-value">₹ {plan.callPrice != null ? plan.callPrice : 0}</span>
                    </div>
                    <div className="recharge-stat">
                        <span className="recharge-stat-label">Plan total</span>
                        <span className="recharge-stat-value">₹ {plan.planTotal != null ? plan.planTotal : 0}</span>
                    </div>
                    <div className="recharge-stat">
                        <span className="recharge-stat-label">Used (all time)</span>
                        <span className="recharge-stat-value">₹ {plan.planUsed != null ? plan.planUsed : 0}</span>
                    </div>
                    <div className="recharge-stat recharge-stat-accent">
                        <span className="recharge-stat-label">Remaining</span>
                        <span className="recharge-stat-value">₹ {plan.remaining != null ? plan.remaining : 0}</span>
                    </div>
                </div>

                <div className="recharge-usage-card">
                    <div className="recharge-usage-head">
                        <strong>{monthLabel} usage</strong>
                        <span>{usage}% used · ₹ {monthUsedAmt} charged · ₹ {monthRechargedAmt} recharged</span>
                    </div>
                    <div className="recharge-usage-bar">
                        <div style={{ width: `${Math.min(100, usage)}%` }} />
                    </div>
                    <p className="recharge-usage-hint">
                        Selected month usage {usage}%. Lifetime usage {lifetimeUsage}%. Credit balance is never wiped monthly.
                        {!isCurrentMonth ? ' Viewing a previous month — patient block uses current wallet only.' : ''}
                    </p>
                    {isCurrentMonth && plan.usageResetLabel ? (
                        <p className={`recharge-usage-reset ${plan.usageResetNear ? 'is-near' : ''}`}>
                            {plan.usageResetLabel}
                        </p>
                    ) : null}
                    {isCurrentMonth && !plan.canCall && plan.configured && plan.blockOnLimit ? (
                        <p className="recharge-warn">Plan limit reached (100%). Add recharge so patients can call again.</p>
                    ) : null}
                    {plan.featureEnabled && Number(plan.callPrice) <= 0 ? (
                        <p className="recharge-warn">Set a per-call price above 0 to start charging attended calls.</p>
                    ) : null}
                    {!plan.featureEnabled ? (
                        <p className="recharge-usage-hint">Recharge Plan is currently Off. Turn Enable to Yes to start tracking and optional blocking.</p>
                    ) : null}
                </div>

                <div className="recharge-forms">
                    <div className="recharge-form-card">
                        <h4>Per-call price</h4>
                        <p className="recharge-form-hint">Charged once when a nurse attends a patient video call.</p>
                        <div className="recharge-input-row">
                            <span>₹</span>
                            <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={this.state.callPriceInput}
                                onChange={(e) => this.setState({ callPriceInput: e.target.value })}
                                placeholder="e.g. 5"
                            />
                        </div>
                        <button
                            type="button"
                            className="btn input-btn recharge-action-btn"
                            disabled={this.props.rechargeLoading}
                            onClick={() => this.props.onUpdateCallPrice(this.state.callPriceInput)}
                        >
                            Save price
                        </button>
                    </div>
                    <div className="recharge-form-card">
                        <h4>Add recharge</h4>
                        <p className="recharge-form-hint">Adds to plan total. No payment gateway — ledger only.</p>
                        <div className="recharge-input-row">
                            <span>₹</span>
                            <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={this.state.rechargeAmount}
                                onChange={(e) => this.setState({ rechargeAmount: e.target.value })}
                                placeholder="e.g. 100"
                            />
                        </div>
                        <input
                            type="text"
                            className="recharge-note-input"
                            value={this.state.rechargeNote}
                            onChange={(e) => this.setState({ rechargeNote: e.target.value })}
                            placeholder="Note (optional)"
                        />
                        <button
                            type="button"
                            className="btn input-btn recharge-action-btn"
                            disabled={this.props.rechargeLoading}
                            onClick={() => {
                                this.props.onRecharge(this.state.rechargeAmount, this.state.rechargeNote);
                                this.setState({ rechargeAmount: '', rechargeNote: '' });
                            }}
                        >
                            Add recharge
                        </button>
                    </div>
                </div>

                <div className="recharge-ledger">
                    <div className="recharge-ledger-head">
                        <h4>Activity · {monthLabel}</h4>
                        <button
                            type="button"
                            className="recharge-refresh"
                            onClick={() => this.props.onRefreshRechargePlan && this.props.onRefreshRechargePlan(selectedMonth)}
                        >
                            Refresh
                        </button>
                    </div>
                    <div className="recharge-ledger-list">
                        {ledger.length === 0 ? (
                            <div className="recharge-ledger-empty">No activity for {monthLabel}.</div>
                        ) : ledger.map((row) => (
                            <div key={row.id} className="recharge-ledger-row">
                                <div className="recharge-ledger-main">
                                    <span className={`recharge-pill recharge-pill-${String(row.eventType || '').toLowerCase()}`}>
                                        {eventLabel(row.eventType)}
                                    </span>
                                    <span className="recharge-ledger-amount">₹ {row.amount}</span>
                                </div>
                                <div className="recharge-ledger-meta">
                                    {row.createdAt ? moment(row.createdAt).format('DD MMM YYYY, HH:mm') : '-'}
                                    {row.actorName ? ` · ${row.actorName}` : ''}
                                    {row.note ? ` · ${row.note}` : ''}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { data, activeTab = 'profile', onTabChange } = this.props;
        const showRechargeTab = Number(data?.Vendor?.isSrmIp) === 1;
        return (
            <div className="content-part px-5 py-4 list">
                <div className="agent-details">
                    {showRechargeTab ? (
                        <div className="recharge-tabs">
                            <button
                                type="button"
                                className={`recharge-tab ${activeTab === 'profile' ? 'is-active' : ''}`}
                                onClick={() => onTabChange && onTabChange('profile')}
                            >
                                Profile
                            </button>
                            <button
                                type="button"
                                className={`recharge-tab ${activeTab === 'recharge' ? 'is-active' : ''}`}
                                onClick={() => onTabChange && onTabChange('recharge')}
                            >
                                Recharge Plan
                            </button>
                        </div>
                    ) : null}
                    {(!showRechargeTab || activeTab === 'profile')
                        ? this.renderProfileTab()
                        : this.renderRechargeTab()}
                </div>
            </div>
        )
    }
}


export default withRouter(ViewVendorProfileScreen);
